import React from "react";

const Resume = () => {
    return (
        <>
            <h1>User Management</h1>
        </>
    );
}

export {Resume};